module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-09.37614199.svg";